import { Button, Group, Modal, Stepper } from '@mantine/core';
import {
	IconCalculator,
	IconCancel,
	IconChevronLeft,
	IconChevronRight,
	IconCircleCheck,
	IconDetails,
	IconFileExport,
	IconShieldCheck,
} from '@tabler/icons-react';
import { useState } from 'react';
import type { VatReturnInputs } from '../types/VatReturn';
import { CalculationsForm } from './CalculationsForm';
import { ExcludingVatForm } from './ExcludingVatForm';
import { ExportConfirmation } from './ExportConfirmation';
import { ReturnDetailsForm } from './ReturnDetailsForm';
import { Title } from '../../../components/Title';

interface ExcelExportModalProps {
	opened: boolean;
	close: () => void;
}

export function VatReturnExportModal({ opened, close }: ExcelExportModalProps) {
	const [selectedStep, setSelectedStep] = useState(0);
	const [returnInputs, setReturnInputs] = useState<VatReturnInputs>({});

	const closeAndReset = () => {
		setSelectedStep(0);
		close();
	};

	return (
		<>
			<Modal
				opened={opened}
				onClose={close}
				title={<Title label={'VAT Return To Excel'} />}
				w={100}
				withCloseButton={false}
				size={'lg'}
			>
				<Stepper
					active={selectedStep}
					onStepClick={setSelectedStep}
					completedIcon={<IconCircleCheck />}
					color={'medepos.0'}
					iconSize={35}
				>
					<Stepper.Step
						icon={<IconDetails />}
						description={'Details'}
						allowStepSelect={false}
					>
						<ReturnDetailsForm
							setInputsInParent={setReturnInputs}
							closeAndResetModal={closeAndReset}
							setSelectedPage={setSelectedStep}
							currentDetails={returnInputs.details}
						/>
					</Stepper.Step>
					<Stepper.Step
						icon={<IconCalculator />}
						description={'Calculations'}
						allowStepSelect={false}
					>
						<CalculationsForm
							setInputsInParent={setReturnInputs}
							setSelectedPage={setSelectedStep}
							currentInputs={returnInputs}
						/>
					</Stepper.Step>
					<Stepper.Step
						icon={<IconShieldCheck />}
						description={'Excluding'}
						allowStepSelect={false}
					>
						<ExcludingVatForm
							setInputsInParent={setReturnInputs}
							setSelectedPage={setSelectedStep}
							currentAfterVats={returnInputs.afterVat}
						/>
					</Stepper.Step>
					<Stepper.Step
						icon={<IconFileExport />}
						description={'Export'}
						allowStepSelect={false} //Change this
					>
						<ExportConfirmation
							fileData={returnInputs}
							setSelectedPage={setSelectedStep}
						/>
					</Stepper.Step>
				</Stepper>
			</Modal>
		</>
	);
}

export function ButtonOrCancel({
	closeAndReset,
	onGoBack,
	onClick,
	form,
}: {
	closeAndReset?: (() => void) | undefined;
	onGoBack: () => void;
	onClick: () => void;
	form?: string;
}) {
	return (
		<Group justify={'flex-end'}>
			{closeAndReset ? (
				<Button
					color={'medepos.1'}
					variant={'filled'}
					leftSection={<IconCancel />}
					onClick={() => closeAndReset()}
				>
					Cancel
				</Button>
			) : (
				<Button
					color={'medepos.1'}
					variant={'filled'}
					leftSection={<IconChevronLeft />}
					onClick={() => onGoBack()}
				>
					Go Back
				</Button>
			)}
			<Button
				color={'medepos.1'}
				variant={'filled'}
				rightSection={<IconChevronRight />}
				onClick={() => onClick()}
				type={'submit'}
				form={form}
				data-cy="next-button"
			>
				Next
			</Button>
		</Group>
	);
}
